import { Config } from '@catalogo/core-configuration';
import { AdsLoadEvent, PageLoadEvent } from '../../../types/events';
import { AdsDatalayer } from '../../../types/datalayer/ads';
import getDefaultEventPayload from '../default-event';
import { getAds } from './helpers';
import { eventData } from '../../../types/datalayer/datalayer';

export default (events: eventData, config: Config): void => {
  const pageload = events['page:load'][0] as PageLoadEvent;
  const adsload = events['ads:load'][0] as AdsLoadEvent;

  const ecommerce = getAds(adsload?.detail?.ads?.ads);
  const defaultEvent = getDefaultEventPayload(pageload, config);

  const event: AdsDatalayer = {
    ...defaultEvent,
    ecommerce,
    event: 'ads',
    eventAction: 'impression',
    eventCategory: 'product',
    eventLabel: 'site',
  };

  window.dataLayer = window.dataLayer || [{}];
  window.dataLayer.push(event);
};
